import React from 'react';
import { JobdatingStatus } from '@/scenes/Events/scenes/components/JobdatingStatus';
import { Planners } from '@/scenes/Event/scenes/Candidate/scenes/JobDating/scenes/Dashboard/components/Cover/Planners';

export const Header = ({ event }) =>  (
  <>
    <JobdatingStatus criteria={[event.visibility, event.dateStatus]} event={event}/>
    <Planners organizations={event.planners._organizations} event={event}/>
  </>
)
